import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';

interface ExternalPortalProps {
  portalId?: string;
  shouldRenderChildrenWithoutPortal?: boolean;
}

export const ExternalPortal: FC<PropsWithChildren<ExternalPortalProps>> = ({
  children,
  portalId = 'externalPortal',
  shouldRenderChildrenWithoutPortal = false,
}) => {
  if (shouldRenderChildrenWithoutPortal) {
    return children;
  }

  const portalIdFormatted = portalId.replace('/', '-');

  try {
    let element = document.querySelector(`#${portalIdFormatted}`);

    if (!element) {
      element = document.createElement('div');
      element.id = portalIdFormatted;

      document.body.appendChild(element);
    }

    return createPortal(children, element);
  } catch (e: any) {
    logError(e.message);
  }
};
